import { ALL_COMPANYS_QUERY } from "../../../graphql/Company/Companys.graphql";
import { ALL_HOLIDAYS_QUERY } from "../../../graphql/Holidays/Holidays.graphql";
import { ALL_SYSTEM_CODES_QUERY } from "../../../graphql/SystemCodes/SystemCodes.graphql";
import { ALL_USERS_QUERY } from "../../../graphql/Users/Users.graphql";
import { ALL_USER_GROUPS_QUERY } from "../../../graphql/UserGroups/UserGroups.graphql";

export default {
  name: "System Administration",
  label: "Admin",
  icon: "cogs",
  permissions: ["ADMIN"],
  active: location => location.pathname.includes("admin"),
  links: [
    {
      name: "Company",
      to: "/admin/company",
      query: ALL_COMPANYS_QUERY
    },
    {
      name: "Holiday Schedule",
      to: "/admin/holidays",
      query: ALL_HOLIDAYS_QUERY
    },
    {
      name: "System Codes",
      to: "/admin/codes",
      query: ALL_SYSTEM_CODES_QUERY
    },
    {
      name: "Users",
      links: [
        {
          name: "Users",
          to: "/admin/users",
          query: ALL_USERS_QUERY
        },
        {
          name: "Users Groups",
          to: "/admin/groups",
          query: ALL_USER_GROUPS_QUERY
        }
      ]
    },
    {
      name: "Dispatching",
      links: [
        {
          name: "Booking Codes",
          to: "/dispatch/booking-codes",
          filters: "BOOKING_CODE_FILTERS"
        }
        // {
        //   name: "Archive Orders",
        //   to: "/admin/order-archive-history"
        // }
      ]
    }
  ]
};
